// extracted by mini-css-extract-plugin
export default {"info-title":"Info_info-title__XM2I8","info-text-wrapper":"Info_info-text-wrapper__23xqf","wrapper":"Info_wrapper__IZddB","narrow-width":"Info_narrow-width__z5Hw6"};